var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block",staticStyle:{"z-index":"999"}},[_c('div',{staticClass:"loader"},[_vm._m(0),_c('h4',[_vm._v(_vm._s(_vm.msg ? _vm.msg :'Cargando')+"...")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ball-pulse-sync"},[_c('div',{staticClass:"bg-success"}),_c('div',{staticClass:"bg-success"}),_c('div',{staticClass:"bg-success"})])
}]

export { render, staticRenderFns }